"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPaypalAmountWithBreakdown = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const src_1 = require("..");
function getPaypalAmountWithBreakdown() {
    const { order_total: orderTotal, } = (0, checkout_frontend_library_1.getApplicationState)();
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    const total = (0, src_1.getValueByCurrency)(orderTotal, currencyCode);
    return {
        currency_code: currencyCode,
        value: total,
        breakdown: {
            item_total: (0, src_1.getPaypalItemsTotal)(),
            shipping: (0, src_1.getPaypalShippingTotal)(),
            tax_total: (0, src_1.getPaypalTaxTotal)(),
            discount: (0, src_1.getPaypalDiscountTotal)(),
            shipping_discount: (0, src_1.getPaypalShippingDiscountTotal)()
        }
    };
}
exports.getPaypalAmountWithBreakdown = getPaypalAmountWithBreakdown;
